import HomeRelatoriosReurb from './Home'

export const items = [
  {
    path: 'home',
    name: 'relatoriosreurb/home',
    component: HomeRelatoriosReurb
  }

]



// WEBPACK FOOTER //
// ./src/screens/relatorios_reurb/config.js